import { Observable } from 'rxjs';

import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class SnLoaderService {
  public loadImage(url: string, width?: number, height?: number): Observable<HTMLImageElement> {
    return new Observable((observer) => {
      const image = new Image(width, height);
      image.src = url;

      image.onload = () => {
        observer.next(image);
        observer.complete();
      };

      image.onerror = (error) => {
        observer.error(error);
      };
    });
  }
}
